import { makeStyles } from "@material-ui/core/styles";

export const paginationStyles = makeStyles(() => ({
  pagination: {
    display: "flex",
    "justify-content": "center",
    margin: "10px 0 20px",
  },
}));
